/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soonki Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Mar 23 2023
 **/

import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const DragHandle = styled.div`
	position: relative;
	background: ${({ theme }) => theme.colors.neutral_00_100};
	mix-blend-mode: normal;
	opacity: 0.4;

	border: 1px solid ${({ theme }) => theme.colors.neutral_50_100};
	box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
	border-radius: 5px;

	width: 40px;
	height: 9px;

	cursor: ns-resize;

	&:hover {
		opacity: 0.8;
	}
`;

export const Text = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: white;
	z-index: 1;
	min-height: 18px;
	min-width: 40px;
`;

export const RoundedText = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: white;
	z-index: 1;
	border-radius: 22px;
	padding: 4px 12px;
	border: 1px solid ${({ theme }) => theme.colors.neutral_50_20};
	min-height: 18px;
	min-width: 40px;
`;

export const DivideLine = styled.hr`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	margin: 0;
	width: 100%;
	mix-blend-mode: normal;
	box-sizing: border-box;
	height: 1px;
	background-color: ${({ theme }) => theme.colors.neutral_50_20};
	border: none;
`;

export const DivideWrap = styled.div`
	width: 100%;
	position: relative;
	display: flex;
	justify-content: center;
`;

export const fillColor = (color: string) => css`
	background-color: ${color};
`;

export const dragCursorCss = css`
	cursor: ns-resize;
`;

export const VerticalDivider = styled.div`
	position: absolute;
	width: 12px;
	margin-right: -5px;
	cursor: col-resize;
	flex-shrink: 0;
	position: relative;
	height: 100%;
	z-index: 10;
	background-color: transparent;
	transition: background-color 0.2s ease;

	&::before {
		content: "";
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 9px;
		height: 40px;
		border-radius: 6px;
		background-color: white;
		box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
		opacity: 0;
		transition:
			opacity 0.2s ease,
			background-color 0.2s ease;
	}

	&:hover::before {
		opacity: 1;
	}
`;
